import { memo } from 'react';
import { Grid } from '@mui/material';
import { SonFormVM } from 'front-office/view-models/certificate/son-form';
import MunicipalityList from 'shell/components/shared/municipality-list';
import PmiTextField from 'shell/components/shared/text-field';

interface ResidenceItalianProps {
  son?: SonFormVM;
  onChange: (key: keyof SonFormVM, value: SonFormVM[keyof SonFormVM]) => void;
}

const ResidenceItalianComponent = ({
  son,
  onChange,
}: ResidenceItalianProps): React.ReactElement => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={6}>
        <MunicipalityList
          label="Comune"
          aria-label="Comune"
          value={son?.italianMunicipalityResidence || null}
          onChange={(element) => {
            onChange('italianMunicipalityResidence', element);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          id="italian-province-residence"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          value={son?.italianProvinceResidence || son?.italianMunicipalityResidence?.province || ''}
          onChange={(event) => {
            onChange('italianProvinceResidence', event.target.value);
          }}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Località"
          id="italian-locality-residence"
          inputProps={{
            maxLength: '120',
          }}
          aria-label="Località"
          fullWidth
          value={son?.italianLocalityResidence}
          onChange={(event) => {
            onChange('italianLocalityResidence', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ResidenceItalianComponent.displayName = 'Residence Italian component';

const ResidenceItalian = memo(ResidenceItalianComponent);

export default ResidenceItalian;
